import { INVENTORY_PAGE as dict } from '@/resources/dict'
import { InventoryListInput } from '@/proxy/inventory/hooks/useSellerInventoryItems/types'

export const DEFAULT_NUMBER_OF_PRODUCTS = 30
export const DEFAULT_PAGE_NUMBER = 1
const DEFAULT_NUMBER_OF_BANNERS_IS_DESKTOP = 5
const DEFAULT_NUMBER_OF_BANNERS_IS_TABLET = 4
const DEFAULT_NUMBER_OF_BANNERS_IS_MOBILE = 3

export const DEFAULT_QUERY_VARIABLES: InventoryListInput = {
  pagination: {
    page: DEFAULT_PAGE_NUMBER,
    perPage: DEFAULT_NUMBER_OF_PRODUCTS,
  },
  filters: {
    brandId: undefined,
    categoriesId: undefined,
    categorizedProductGroupId: undefined,
    hasTakeRateSeller: undefined,
    isAvailable: undefined,
    isExternalCodeSet: undefined,
    isIdealPortfolio: undefined,
    isProductFavorite: undefined,
    isScheduledItemAvailable: undefined,
    offerState: undefined,
    priceVariationType: undefined,
    productGroupId: undefined,
    productName: undefined,
    unavailableDays: undefined,
    availableDays: undefined,
    variantIds: undefined,
    hasActivePocDiscount: undefined,
    isBoostedProduct: undefined,
  },
}

export const EnumAvailability = {
  COMMON: {
    ACTIVE: 1,
    INACTIVE: 2,
  },
  SCHEDULED: {
    ACTIVE: 3,
    INACTIVE: 4,
  },
}

export const FEATURE_TOGGLES = {
  SPECIAL_LIST_BANNERS: 'special_list_banners_portfolio',
  ENABLE_NEW_SPECIAL_LIST: 'enable_new_special_list',
  ENABLE_SPECIAL_OFFER_BANNER: 'enable_special_offer_banner',
  SET_INVENTORY_INITIAL_TAB: 'set_inventory_initial_tab',
  ENABLE_FILTER_TAGS: 'enable_filter_tags',
  ENABLE_PRICE_VARIATION: 'enable_price_variation',
  ENABLE_SELLER_PROMOTION: 'enable_seller_promotion',
  ENABLE_SELLER_PROMOTION_SCHEDULE: 'enable_seller_promotion_schedule',
  ON_SALE_CATEGORIES_FILTER: 'on_sale_categories_filter',
  CAMPAIGN_PAGE_BANNERS: 'campaign_page_banners',
  SELLER_CAMPAIGNS_ENABLED: 'seller_campaings_enabled',
  SELLER_CBE_BUTTON_ACCEPT_ALL_ORDERS: 'seller_cbe_button_accept_all_orders',
  SELLER_CBE_SKU_AVAILABILITY: 'seller_cbe_sku_availability',
  SELLER_PORTFOLIO_MIGRATE_UPDATE_INVENTORY:
    'seller_portfolio_migrate_update_inventory',
}

export const FEATURE_TOGGLES_HEXA_V2 = {
  SELLER_HEXA_PORTFOLIO_BANNERS: 'seller_hexa_portfolio_banners',
  SELLER_HEXA_PORTFOLIO_BRANDS: 'seller_hexa_portfolio_brands',
  SELLER_HEXA_PORTFOLIO_FILTERS: 'seller_hexa_portfolio_filters',
  SELLER_HEXA_PORTFOLIO_TABS: 'seller_hexa_portfolio_tabs',
  SELLER_HEXA_PORTFOLIO_TABLE: 'seller_hexa_portfolio_table',
  SELLER_HEXA_PORTFOLIO_PRODUCT_CODE_MODAL:
    'seller_hexa_portfolio_product_code_modal',
  SELLER_HEXA_PORTFOLIO_PRODUCT_REPORT_MODAL:
    'seller_hexa_portfolio_product_report_modal',
  NEW_SELLER_PORTFOLIO_TABLE: 'new_seller_portfolio_table',
}

export const SCHEDULED_AVAILABILITY_OPTIONS = [
  { label: dict.commonActive, value: EnumAvailability.COMMON.ACTIVE },
  { label: dict.commonInactive, value: EnumAvailability.COMMON.INACTIVE },
  { label: dict.scheduledActive, value: EnumAvailability.SCHEDULED.ACTIVE },
  {
    label: dict.scheduledInactive,
    value: EnumAvailability.SCHEDULED.INACTIVE,
  },
]

export const AVAILABILITY_OPTIONS = [
  { label: dict.available, value: 'true' },
  { label: dict.unavailable, value: 'false' },
]

export const INTEGRATION_FILTER_OPTIONS = [
  { label: dict.hasProductCode, value: 'external-code-true' },
  { label: dict.hasntProductCode, value: 'external-code-false' },
]

export const MARKETPLACE_FILTER = {
  label: dict.marketplaceFilter,
  value: 'marketplace',
}

export const POC_DISCOUNT_FILTER_VALUES = {
  ACTIVE: 'active-poc-discount',
  INACTIVE: 'inactive-poc-discount',
} as const

export const PROMOTION_FILTER = {
  label: dict.activePocDiscount,
  value: POC_DISCOUNT_FILTER_VALUES.ACTIVE,
}

export const PROMOTION_INACTIVE_FILTER = {
  label: dict.inactivePocDiscount,
  value: POC_DISCOUNT_FILTER_VALUES.INACTIVE,
}
export const NEW_BRAND_FILTER_SLIDER_SETTINGS = {
  infinite: true,
  adaptiveHeight: true,
  variableWidth: true,
  slidesToScroll: 5,
  responsive: [
    {
      breakpoint: 1920,
      settings: {
        slidesToShow: 16,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 10,
      },
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 380,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        variableWidth: true,
      },
    },
  ],
}

export const FILTER_SLIDER_SPECIAL_BANNERS_SETTINGS = (
  enabledSpecialOfferBannerFeatureToggle: boolean | undefined
) => ({
  mobileFirst: true,
  slidesToScroll: 7,
  slidesToShow: 7,
  dots: true,
  infinite: true,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1921,
      settings: {
        slidesToShow: enabledSpecialOfferBannerFeatureToggle ? 7 : 6,
        slidesToScroll: enabledSpecialOfferBannerFeatureToggle ? 7 : 6,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: DEFAULT_NUMBER_OF_BANNERS_IS_DESKTOP,
        slidesToScroll: DEFAULT_NUMBER_OF_BANNERS_IS_DESKTOP,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: DEFAULT_NUMBER_OF_BANNERS_IS_TABLET,
        slidesToScroll: DEFAULT_NUMBER_OF_BANNERS_IS_TABLET,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: DEFAULT_NUMBER_OF_BANNERS_IS_MOBILE,
        slidesToScroll: DEFAULT_NUMBER_OF_BANNERS_IS_MOBILE,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 380,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
})

export const CURRENT_SURVEY_ID = 'f0220300-d147-458f-823f-e0b92c9db392'

export const PROMOTION_INTEREST_SURVEY_ID =
  '607170a8-a5bc-412d-94c3-acb5bb96cd95'

export const BANNERS_LIST_ID = {
  IDEAL_PORTFOLIO: '9feb2cfa-3461-4af1-827e-171c83dfabcf',
  BEST_SELLERS_REGION: '473f7d39-159d-4086-ac16-ec66e9a81228',
  WINES_SELLERS: '5fa03358-8ccb-4507-ba5e-3a0c17e390ab',
  DISTILLED_SELLERS: 'a4bd203a-20d9-4959-b29f-0a1e15f57ac4',
  SNACK_SELLERS: '953cd78a-d452-4e57-8e16-ff96ab7788b5',
  WINES_FESTIVAL: 'c44d506c-0a28-4dea-9ba0-fd67e6d1fd7b',
  GROCERY_SELLERS: '524c2455-b062-42ed-8be5-69bf20dfefcc',
  SPECIAL_OFFER: 'c06d9089-4190-4268-ba2b-707b48f71702',
  MOST_WANTED_SELLERS: '13ce2402-146e-4107-a98b-9fc3c9146b13',
  NEW_PRODUCTS: 'fa3da47d-38b8-44e3-ac77-c549d7e91add',
  SELLER_PROMO_SPECIAL_OFFER: 'a8a20349-52a6-44c1-8e58-3cbf6b673937',
  MORE_COMPETITIVE_REGION: '61cf2435-c328-49a4-9bb3-d9d9685bd2e7',
  COMPLEMENT_CUP_ORDERS: '2878e8b2-576e-40bf-9469-a69f1d7e25d0',
  MOST_SEARCHED_PRODUCTS: 'eb56e1d0-6369-4ede-aa84-3c53988c1a7a',
  BIRTHDAY_ZE: 'b7d13921-0387-4e23-81c7-b4703ba28d5a',
  OBJECTION_PRODUCTS: '693c8dcd-c0f4-4916-8049-700194b7e600',
  BLACK_FRIDAY: 'ce23752d-bb61-42d8-a84b-d32d8f2abe55',
}

export const CATEGORIZED_PRODUCT_GROUP_ID = 'categorizedProductGroupId'

export const SEGMENT_COMPONENT_CATEGORY = {
  BUTTON: 'button',
  TOOLTIP: 'tooltip',
  TOGGLE: 'toggle',
} as const

export const SEGMENT_DISCOUNT_CLICKED_COMPONENT_NAME = {
  I_AM_INTERESTED: 'Tenho interesse',
  ACTIVATE_DISCOUNT: 'Ativar desconto',
  SCHEDULE_DISCOUNT: 'Agendar desconto',
  EDIT_DISCOUNT: 'Editar desconto',
} as const

export const SEGMENT_COMPONENT_NAME = {
  SEND: 'Enviar',
  CLOSE: 'Fechar',
  BACK: 'Voltar',
  CONTINUE: 'Continuar',
  SAVE: 'Salvar',
  CANCEL: 'Cancelar',
  MORE_INFO: 'Mais informações',
  SAVE_SCHEDULE: 'Salvar agendamento',
  CANCEL_SCHEDULE: 'Cancelar agendamento',
  DELETE_SCHEDULE: 'Excluir agendamento',
  EDIT_SCHEDULE: 'Editar agendamento',
} as const

export const SEGMENT_MODAL_NAME = {
  DISCOUNT_INTEREST: 'Discount interest',
  DISCOUNT_SCHEDULING: 'Discount scheduling',
  PRODUCT_CODE: 'Product Code',
  PRODUCT_DISPUTE: 'Product Dispute',
} as const

export enum PROMOTION_SCHEDULE_DAYS_ENUM {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export enum PROMOTION_SCHEDULE_PERIODS_ENUM {
  MORNING = 'MORNING',
  AFTERNOON = 'AFTERNOON',
  EVENING = 'EVENING',
  LATE_NIGHT = 'LATE_NIGHT',
}

export const PROMOTION_SCHEDULE_DAYS = [
  {
    label: dict.promotionSchedule.weekDays.monday,
    value: PROMOTION_SCHEDULE_DAYS_ENUM.MONDAY,
  },
  {
    label: dict.promotionSchedule.weekDays.tuesday,
    value: PROMOTION_SCHEDULE_DAYS_ENUM.TUESDAY,
  },
  {
    label: dict.promotionSchedule.weekDays.wednesday,
    value: PROMOTION_SCHEDULE_DAYS_ENUM.WEDNESDAY,
  },
  {
    label: dict.promotionSchedule.weekDays.thursday,
    value: PROMOTION_SCHEDULE_DAYS_ENUM.THURSDAY,
  },
  {
    label: dict.promotionSchedule.weekDays.friday,
    value: PROMOTION_SCHEDULE_DAYS_ENUM.FRIDAY,
  },
  {
    label: dict.promotionSchedule.weekDays.saturday,
    value: PROMOTION_SCHEDULE_DAYS_ENUM.SATURDAY,
  },
  {
    label: dict.promotionSchedule.weekDays.sunday,
    value: PROMOTION_SCHEDULE_DAYS_ENUM.SUNDAY,
  },
]

export const PROMOTION_SCHEDULE_PERIODS = [
  {
    label: dict.promotionSchedule.periods.morning,
    value: PROMOTION_SCHEDULE_PERIODS_ENUM.MORNING,
  },
  {
    label: dict.promotionSchedule.periods.afternoon,
    value: PROMOTION_SCHEDULE_PERIODS_ENUM.AFTERNOON,
  },
  {
    label: dict.promotionSchedule.periods.evening,
    value: PROMOTION_SCHEDULE_PERIODS_ENUM.EVENING,
  },
  {
    label: dict.promotionSchedule.periods.lateNight,
    value: PROMOTION_SCHEDULE_PERIODS_ENUM.LATE_NIGHT,
  },
]
